export function formatAddress(address, isPostCodeRequired) {
    return {
        firstLine: `${address.street} ${address.streetNumber}`,
        secondLine: `${isPostCodeRequired && address.postCode !== null
            ? address.postCode + " "
            : ""}${address.city}`,
    };
}
export function formatAddressAsSingleLine(address, isPostCodeRequired) {
    const result = formatAddress(address, isPostCodeRequired);
    return `${result.firstLine}, ${result.secondLine}`;
}
